import { Component, PropTypes } from 'react';
import productCDN from '@surfline/quiver-assets';

// https://medium.com/@hotdang_ca/how-i-wrote-a-reactjs-adblock-detection-that-didnt-actually-suck-812be52fb1ef
// http://www.detectadblock.com/
class DetectAdBlock extends Component {
  static propTypes = {
    setAdBlock: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const head = document.getElementsByTagName('head')[0];
    const oldScript = document.getElementById('adblock-detection');
    if (oldScript) head.removeChild(oldScript);
    const script = document.createElement('script');
    script.id = 'adblock-detection';
    script.type = 'text/javascript';
    script.src = `${productCDN}/scripts/ads.js`;
    script.onload = () => this.props.setAdBlock(false);
    script.onerror = () => this.props.setAdBlock(true);
    head.appendChild(script);
  }

  render() {
    return null;
  }
}

export default DetectAdBlock;



// WEBPACK FOOTER //
// ./src/components/DetectAdBlock/DetectAdBlock.js